const BASE_URL = process.env.REACT_APP_API_URL;

function getToken() {
    return localStorage.getItem("d_c_c_t");
}


export async function getAllCertifications(query:string, perPage:number, pageNo:number) {
    try {
        const response = await fetch(`${BASE_URL}/certificates?query=${query}&perPage=${perPage}&pageNo=${pageNo}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${getToken()}`,
            },
        });

        if (!response.ok) {
            throw new Error('Failed to fetch certifications');
        }

        const result = await response.json();
        return result;
    } catch (error) {
        console.error('Error fetching certifications:', error);
        throw new Error('Error fetching certifications');
    }
}


export async function uploadFile(data:any) {
    try {
        const response = await fetch(`${BASE_URL}/upload/certificate`, {
            method: 'POST',
            body: data,
            headers: {
                'Authorization': `Bearer ${getToken()}`,
            },
        });
        return response;
    } catch (error: any) {
        console.error('Error uploading file:', error);
        throw new Error('Error uploading file');
    }
}

export async function deleteCertification(id:any){
    try {
        const response = await fetch(`${BASE_URL}/certificates/${id}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${getToken()}`,
            },
        });

        if (!response.ok) {
            throw new Error('Failed to delete certifications');
        }

        const result = await response.json();
        return result;
    } catch (error) {
        console.error('Error deleting certifications:', error);
        throw new Error('Error deleting certifications');
    }
}

export async function assignCertificateToTenant(data:any){
    try {

        const response = await fetch(`${BASE_URL}/upload/assign_certificate`, {
            method: 'POST',
            body: data,
            headers: {
                'Authorization': `Bearer ${getToken()}`,
            },
        });
        return response;
    } catch (error) {
        console.error('Error assigning certificate to tenant:', error);
        throw new Error('Error assigning certificate to tenant');
    }
}




